import React from "react";
import { ArrowRight } from "lucide-react";

// "Remove this value from P9?" asked before a value is moved to another position (default: Yes).
export function AiMoveConfirm({ review, t }) {
    const pm = review?.pendingMove;
    if (!pm) return null;
    const src = review.items.find((x) => x._id === pm.fromId), dst = review.items.find((x) => x._id === pm.toId);
    if (!src || !dst) return null;
    const v = src.f[pm.key]?.value, old = dst.f[pm.key]?.value;
    const from = src.f.name?.value || "\u2014", to = dst.f.name?.value || "\u2014";
    const hasOld = old !== "" && old != null && !(pm.key === "qty" && !dst.f.qty?.box);
    return (
        <div data-testid="ai-move-confirm" className="fixed inset-0 z-[80] bg-black/50 flex items-center justify-center p-4" onMouseDown={(e) => { if (e.target === e.currentTarget) review.setPendingMove(null); }}>
            <div className="w-full max-w-sm rounded-xl border border-[#1e293b] bg-[#111827] p-4 text-slate-100 shadow-2xl"
                onKeyDown={(e) => { if (e.key === "Escape") review.setPendingMove(null); }}>
                <div className="text-xs font-mono text-slate-400 mb-1">{t(`ai_f_${pm.key}`)}</div>
                <div className="flex items-center gap-2 text-lg font-semibold mb-3">
                    <span data-testid="ai-move-value" className="px-2 py-0.5 rounded bg-blue-600/25 border border-blue-500/50">{String(v ?? "")}</span>
                    <span className="font-mono text-slate-300">{from}</span><ArrowRight className="w-4 h-4 text-cyan-300" /><span className="font-mono text-cyan-200">{to}</span>
                </div>
                {hasOld && <div data-testid="ai-move-overwrite" className="text-xs text-amber-300 mb-2">{t("mv_overwrite", { to, old: String(old) })}</div>}
                <div className="text-sm mb-4">{t("mv_ask_remove", { from })}</div>
                <div className="flex gap-2 justify-end">
                    <button data-testid="ai-move-cancel" onClick={() => review.setPendingMove(null)} className="h-8 px-3 rounded text-xs border border-[#1e293b] text-slate-300 hover:bg-[#182232]">{t("ai_cancel")}</button>
                    <button data-testid="ai-move-no" onClick={() => review.doMove(false)} className="h-8 px-3 rounded text-xs border border-[#334155] text-slate-100 hover:bg-[#182232]">{t("mv_no")}</button>
                    <button data-testid="ai-move-yes" autoFocus onClick={() => review.doMove(true)} className="h-8 px-4 rounded text-xs font-semibold bg-blue-600 hover:bg-blue-500 text-white">{t("mv_yes")}</button>
                </div>
            </div>
        </div>
    );
}
